<template>
	<div class="form-group">
		<label v-if="field.question">{{ field.question }}</label>
		<div v-if="field.description" v-html="field.description"></div>
		<template v-if="readonly">
			<div v-html="field.value"></div>
		</template>
		<template v-else>
			<vue-editor v-model="field.value" :disabled="readonly"></vue-editor>
		</template>
	</div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
	components: {
		VueEditor
	},
	props: ['field', 'readonly']
};
</script>
